import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Order {
  name: string;
  lastName: string;
  email: string;
  phone: string;
  size: string;
  color: string;
  addFlag: boolean;
  addInitials: boolean;
  initials?: string;
  nickname?: string;
}

const PRICE = 29.99;
const FLAG_PRICE = 5;
const INITIALS_PRICE = 3;

export default function Payment() {
  const navigate = useNavigate();
  const [order, setOrder] = useState<Order | null>(null);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const savedOrder = localStorage.getItem('currentOrder');
    if (!savedOrder) {
      navigate('/order-details');
      return;
    }

    const parsedOrder = JSON.parse(savedOrder) as Order;
    setOrder(parsedOrder);

    let orderTotal = PRICE;
    if (parsedOrder.addFlag) orderTotal += FLAG_PRICE;
    if (parsedOrder.addInitials) orderTotal += INITIALS_PRICE;
    setTotal(orderTotal);
  }, [navigate]);

  if (!order) return null;

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-6">Resumen del pedido</h2>

          <div className="space-y-4">
            <div className="border-b pb-4">
              <h3 className="font-medium mb-2">Datos personales</h3>
              <p>Nombre: {order.name} {order.lastName}</p>
              <p>Email: {order.email}</p>
              <p>Teléfono: {order.phone}</p>
            </div>

            <div className="border-b pb-4">
              <h3 className="font-medium mb-2">Detalles de la sudadera</h3>
              <p>Talla: {order.size}</p>
              <p>Color: {order.color}</p>
              {order.addFlag && <p>Bandera en mangas: Sí</p>}
              {order.addInitials && (
                <p>Iniciales en mangas: {order.initials}</p>
              )}
              {order.nickname && <p>Mote: {order.nickname}</p>}
            </div>

            <div className="border-b pb-4">
              <h3 className="font-medium mb-2">Desglose</h3>
              <p>Sudadera base: €{PRICE.toFixed(2)}</p>
              {order.addFlag && (
                <p>Bandera en mangas: €{FLAG_PRICE.toFixed(2)}</p>
              )}
              {order.addInitials && (
                <p>Iniciales en mangas: €{INITIALS_PRICE.toFixed(2)}</p>
              )}
              <p className="font-bold mt-2">
                Total: €{total.toFixed(2)}
              </p>
            </div>

            <div className="pt-4">
              <button
                type="button"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={() => {
                  alert('Integración con pasarela de pago pendiente');
                }}
              >
                Proceder al pago
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}